import { useEffect, useState } from "react";
import papi from "@/lib/partnerApi";
import { SectionHead } from "./VdaShared";
import { CheckCircle2, XCircle, Database, KeyRound, ShieldCheck } from "lucide-react";

const SCORE_RUBRIC = [
  ["Category matched", 20], ["City / service area", 15], ["Public phone", 15],
  ["Website", 10], ["Public email", 10], ["Portfolio", 10],
  ["Public reviews", 10], ["Instagram", 5], ["Experience info", 5],
];

export default function VdaSettings() {
  const [cats, setCats] = useState([]);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    papi.get("/vda/categories").then((r) => setCats(r.data)).catch(() => {});
    papi.get("/vda/dashboard").then((r) => setTotal(r.data.unique)).catch(() => {});
  }, []);

  return (
    <div className="max-w-3xl">
      <SectionHead title="Settings" desc="Data source configuration and scoring rubric." />

      <div className="space-y-6">
        <Card icon={KeyRound} title="Data Source">
          <Line ok label="Google Places API" value="Classic Text Search + Place Details — connected" />
          <Line ok label="Data Integrity" value="Real listings only — missing fields stored as “Not Available”, never invented" />
        </Card>

        <Card icon={Database} title="Workspace">
          <Line label="Active categories" value={`${cats.filter((c) => c.active).length} of ${cats.length}`} />
          <Line label="Total unique prospects" value={String(total)} />
          <Line ok label="Deduplication" value="By Google Place ID, normalized name+city, and website" />
        </Card>

        <Card icon={ShieldCheck} title="Discovery Score Rubric (out of 100)">
          <div className="grid grid-cols-2 gap-x-8 gap-y-2">
            {SCORE_RUBRIC.map(([l, p]) => (
              <div key={l} className="flex items-center justify-between border-b border-slate-50 py-1.5 text-sm">
                <span className="text-slate-600">{l}</span><span className="font-bold tabular-nums text-teal-600">+{p}</span>
              </div>
            ))}
          </div>
          <div className="mt-4 flex gap-4 text-xs">
            <span className="rounded-full bg-emerald-500/15 px-3 py-1 font-semibold text-emerald-700">High ≥ 80</span>
            <span className="rounded-full bg-amber-500/15 px-3 py-1 font-semibold text-amber-700">Medium ≥ 60</span>
            <span className="rounded-full bg-slate-400/15 px-3 py-1 font-semibold text-slate-600">Low &lt; 60</span>
          </div>
        </Card>
      </div>
    </div>
  );
}

function Card({ icon: Icon, title, children }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h3 className="mb-4 flex items-center gap-2 font-display text-base font-bold text-slate-900"><Icon className="h-4 w-4 text-teal-500" />{title}</h3>
      <div className="space-y-3">{children}</div>
    </div>
  );
}
function Line({ ok, label, value }) {
  return (
    <div className="flex items-start gap-3 text-sm">
      {ok ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" /> : <span className="mt-0.5 h-4 w-4 shrink-0" />}
      <div><span className="font-medium text-slate-700">{label}</span><p className="text-slate-500">{value}</p></div>
    </div>
  );
}
